import { createInMemoryAtom } from '@exodus/atoms'

const createFiatUserAtom = () =>
  createInMemoryAtom({
    defaultValue: {
      authenticated: false,
      kyc: {},
    },
  })

const fiatUserAtomDefinition = {
  id: 'fiatUserAtom',
  type: 'atom',
  factory: createFiatUserAtom,
  public: true,
}

export default fiatUserAtomDefinition
